import React from 'react'
import { connect } from 'react-redux'
import { LocalForm, Control, actions } from 'react-redux-form'

import {
  accounts_autocomplete_filter
} from '../actions'

const {M} = window
const {FormSelect, Autocomplete} = M

const mapStateToProps = state => {
  return {
    current_user: state.auth.current_user.data,
    account_data: state.account.filter_query.account_data,
    account_names: state.account.filter_query.account_names,
    query: state.account.filter_query.query,

  }
}

const mapDispatchToProps = dispatch => {
  return {
    getAutocompleteOptions: (query) => dispatch( accounts_autocomplete_filter(query) ),
  }
}

class ConnectedUserFilters extends React.Component {
  constructor() {
    super()
    this.state={
      autocomplete: null,
      statusSelect: null,
      roleSelect: null,
      searchValue: ''
    }
  }

  attachDispatch(dispatch) {
    this.formDispatch = dispatch;
  }

  changeOptions(e) {
    const newValue = e.target.value
    if ( newValue === null) {
      return
    }
    const value = newValue.trim()
    const { searchValue } = this.state
    const { account_names } = this.props
    const total_accounts = Object.keys(account_names).length
    if ( searchValue === '' || (value.includes(searchValue) && total_accounts === 20) || (!value.includes(searchValue)) ) {
      this.props.getAutocompleteOptions(value)
    }
  }

  componentDidMount() {
    const {formDispatch} = this
    const el1 = document.getElementById("filterRole")
    const roleSelect = FormSelect.init(el1)

    const el2 = document.getElementById("filterStatus")
    const statusSelect = FormSelect.init(el2)

    const el3 = document.getElementById("filterAccount")
    const autocomplete = Autocomplete.init(el3, {
      data: {},
      limit: 4,
      onAutocomplete: function(value) {
        formDispatch(actions.change('localFilters.account', value))
      }
    })

    this.setState({autocomplete: autocomplete, roleSelect: roleSelect, statusSelect: statusSelect})
  }

  componentDidUpdate(prevProps, prevState) {
    const {account_names, query} = this.props
    const previousQuery = prevProps.query
    const { filters } = this.state
    const oldFilters = prevState.filters

    if (JSON.stringify(oldFilters) !== JSON.stringify(filters)) {
      console.log(filters)
      Object.keys(filters).forEach( filter => {
        const key=`localFilters.${filter}`
        this.formDispatch(actions.change(key, filters[filter]));
      })
    }

    if ( previousQuery !== query ) {
      const {autocomplete} = this.state
      return autocomplete.updateData(account_names)
    }
  }

  handleSubmit(values) {
    console.log(values)
    this.props.setFilters(values)
  }

  render(){
    const {current_user} = this.props

    if (current_user.role !== 'admin') {
      return ''
    }

    return (
      <table className="bordered striped highlight responsive-table users-list">
        <tbody>
          <tr className="userFilters">
            <td>
              <LocalForm
                model="localFilters"
                getDispatch={(dispatch) => this.attachDispatch(dispatch)}
                onSubmit = { (values) => {
                  this.handleSubmit(values)
                }}
                onChange = { (values) => {
                  this.handleSubmit(values)
                }}
                initialState={{
                  role: "",
                  status: "",
                  account: "",
                  data: ""
                }}
              >
                <div className="row" title="Use criteria to filter users">

                  <div className="input-field col s12 l3 xl3">
                    <label className="active" htmlFor="filterRole">Filter by Role</label>
                    <Control.select id="filterRole" className="roleSelect" model=".role" onChange={(e) => {
                      e.preventDefault()
                    }}>
                      <option value="">All</option>
                      <option value="user">User</option>
                      <option value="manager">Manager</option>
                      <option value="admin">Administrator</option>
                    </Control.select>
                  </div>

                  <div className="input-field col s12 l3 xl3">
                    <label className="alwaysActive" htmlFor="filterData">Filter by Email/Name</label>
                    <Control.text id="filterData" model=".data" onChange={e=>{
                      this.changeOptions(e)
                    }}/>
                  </div>

                  <div className="input-field col s12 l3 xl3">
                    <label className="alwaysActive" htmlFor="filterAccount">Filter by Account Name</label>
                    <Control.text id="filterAccount" model=".account" onChange={e=>{
                      this.changeOptions(e)
                    }}/>
                  </div>

                  <div className="input-field col s12 l3 xl3">
                    <label className="active" htmlFor="filterStatus">Filter by Status</label>
                    <Control.select id="filterStatus" className="roleSelect" model=".status" onChange={(e) => {
                      e.preventDefault()
                    }}>
                      <option value="">All</option>
                      <option value="active">Active</option>
                      <option value="locked">Locked</option>
                      <option value="disabled">Disabled</option>
                    </Control.select>
                  </div>

                </div>
              </LocalForm>
            </td>
          </tr>
        </tbody>
      </table>

    )
  }
}

const UserFilters = connect(mapStateToProps, mapDispatchToProps)(ConnectedUserFilters)

export default UserFilters



// WEBPACK FOOTER //
// ./src/js/components/UserFilters.js